import { render, staticRenderFns } from "./ApproveAgency.vue?vue&type=template&id=00e6a21f&scoped=true"
import script from "./ApproveAgency.vue?vue&type=script&lang=js"
export * from "./ApproveAgency.vue?vue&type=script&lang=js"
import style0 from "./ApproveAgency.vue?vue&type=style&index=0&id=00e6a21f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e6a21f",
  null
  
)

export default component.exports